export interface IUserGameHistory {
  userNum: number;
  nickname: string;
  gameId: number;
  seasonId: number;
  matchingMode: number;
  matchingTeamMode: number;
  characterNum: number;
  characterLevel: number;
  gameRank: number;
  playerKill: number;
  serverName: string;
  playerAssistant: number;
  monsterKill: number;
  bestWeapon: number;
  bestWeaponLevel: number;
  masteryLevel: Record<string, number>;
  equipment: Record<string, number>;
  versionMajor: number;
  versionMinor: number;
  skillLevelInfo: Record<string, number>;
  skillOrderInfo: Record<string, number>;
  maxHp: number;
  maxSp: number;
  attackPower: number;
  defense: number;
  hpRegen: number;
  spRegen: number;
  attackSpeed: number;
  moveSpeed: number;
  outOfCombatMoveSpeed: number;
  sightRange: number;
  attackRange: number;
  criticalChance: number;
  criticalStrikeDamage: number;
  coolDownReduction: number;
  lifeSteal: number;
  amplifierToMonster: number;
  trapDamage: number;
  gainExp: number;
  startDtm: string;
  duration: number;
  mmrBefore: number;
  damageToPlayer: number;
  damageToMonster: number;
  killerUserNum: number;
  playTime: number;
  watchTime: number;
  totalTime: number;
  botAdded: number;
  botRemain: number;
  restrictedAreaAccelerated: number;
  safeAreas: number;
  killer: string;
  killDetail: string;
  causeOfDeath: string;
  teamNumber: number;
  preMade: number;
  gainedNormalMmrKFactor: number;
}
